// Modal de confirmação genérico, usado em dezenas de telas. Desde o Aeros
// Dark é uma casca fina sobre AerosConfirmModal (mockup "Modal Excluir A"),
// para não existirem dois modais de confirmação com caras diferentes.
//
// A API pública NÃO mudou: `title`, `children` (vira a descrição), `open`,
// `onClose` — que continua sendo chamado com `false`, porque boa parte das
// telas passa um setter de estado direto — e `onConfirm`, disparado depois
// do fechamento, como antes. `tone`, `icon` e `confirmLabel` são opcionais,
// para quem quiser o ícone de lixeira ou um rótulo mais específico.
import React from "react";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

import { i18n } from "../../translate/i18n";
import AerosConfirmModal from "../AerosConfirmModal";

const ConfirmationModal = ({
	title,
	children,
	open,
	onClose,
	onConfirm,
	tone = "warning",
	icon,
	confirmLabel,
	cancelLabel,
}) => {
	const close = () => onClose(false);

	return (
		<AerosConfirmModal
			open={Boolean(open)}
			onClose={close}
			onConfirm={() => {
				close();
				onConfirm();
			}}
			icon={icon || <HelpOutlineIcon />}
			tone={tone}
			title={title}
			description={children}
			confirmLabel={confirmLabel || i18n.t("confirmationModal.buttons.confirm")}
			cancelLabel={cancelLabel || i18n.t("confirmationModal.buttons.cancel")}
		/>
	);
};

export default ConfirmationModal;
